var _style, _g, _g2, _g3, _line, _line2, _g4, _g5, _g6, _path, _path2, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 376.6 179.5",
    style: {
      enableBackground: "new 0 0 376.6 179.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.6061;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:4.4166;stroke-linecap:round;}\r\n\t.st3{fill:none;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:4.0151;}\r\n\t.st5{stroke:#000000;stroke-width:2.0882;}\r\n\t.st6{stroke:#000000;stroke-width:2.0878;stroke-miterlimit:3.9992;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:2.7425;stroke-linecap:round;}\r\n\t.st8{fill:#F6EB7A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.7,35.5c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5v13.6L225,32.8c1.1-1.1,2.2-1.7,3.8-1.7c2.5,0,4.1,1.9,4.1,4.1 c0,1.4-0.6,2.4-1.6,3.4l-11.4,10.6l12.4,15.6c0.7,0.9,1.2,1.8,1.2,3.1c0,2.5-1.9,4.3-4.5,4.3c-1.7,0-2.8-0.9-3.8-2.1L213.7,55 l-5.1,4.7v8.1c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.7,56.6v-0.1c0-8.9,7.2-16.1,16.8-16.1c9.6,0,16.7,7.1,16.7,16v0.1c0,8.9-7.2,16.1-16.8,16.1 C243.8,72.6,236.7,65.5,236.7,56.6z M261.5,56.6v-0.1c0-4.6-3.3-8.6-8.2-8.6c-5,0-8,3.9-8,8.4v0.1c0,4.6,3.3,8.6,8.2,8.6 C258.5,65,261.5,61.1,261.5,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,72.6c-9.3,0-16.2-6.5-16.2-16v-0.1c0-8.8,6.3-16.1,15.3-16.1c10.4,0,14.9,8.5,14.9,14.9c0,2.5-1.8,4.2-4.1,4.2h-17.4 c0.9,4,3.6,6.1,7.6,6.1c2.4,0,4.5-0.8,6.2-2.1c0.6-0.5,1.2-0.7,2.1-0.7c2,0,3.4,1.5,3.4,3.5c0,1.2-0.5,2-1.2,2.6 C334,71.1,330.5,72.6,326,72.6z M331.6,54c-0.5-3.9-2.8-6.6-6.5-6.6c-3.6,0-6,2.6-6.7,6.6H331.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.2,69.4v-0.2c0-1,0.4-1.8,1.3-2.8l26.3-30.8h-24.3c-1.4,0-2.7-1.1-2.7-2.6c0-1.4,1.2-2.7,2.7-2.7h29.6 c1.7,0,3,1.1,3,2.5V33c0,1-0.4,1.8-1.3,2.8l-26.3,30.8h25.3c1.4,0,2.7,1.2,2.7,2.6c0,1.4-1.2,2.7-2.7,2.7h-30.7 C274.6,71.9,273.2,70.8,273.2,69.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.2,69.4v-0.2c0-1,0.4-1.8,1.3-2.8l26.3-30.8h-24.3c-1.4,0-2.7-1.1-2.7-2.6c0-1.4,1.2-2.7,2.7-2.7h29.6 c1.7,0,3,1.1,3,2.5V33c0,1-0.4,1.8-1.3,2.8l-26.3,30.8h25.3c1.4,0,2.7,1.2,2.7,2.6c0,1.4-1.2,2.7-2.7,2.7h-30.7 C274.6,71.9,273.2,70.8,273.2,69.4z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    className: "st2",
    x1: 243.7,
    y1: 33.2,
    x2: 265,
    y2: 33.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    className: "st2",
    x1: 317.4,
    y1: 33.2,
    x2: 338.7,
    y2: 33.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.7,122.3c-0.7-0.5-1.2-1.4-1.2-2.4c0-1.7,1.3-3,3-3c0.8,0,1.4,0.3,1.8,0.6c2.2,1.6,4.6,2.6,7.5,2.6 c2.6,0,4.2-1,4.2-2.8v-0.1c0-1.6-1-2.5-5.9-3.7c-5.9-1.5-9.7-3.1-9.7-8.9v-0.1c0-5.3,4.3-8.8,10.2-8.8c3.6,0,6.6,0.9,9.3,2.6 c0.7,0.4,1.4,1.3,1.4,2.5c0,1.7-1.3,3-3,3c-0.6,0-1.1-0.2-1.6-0.5c-2.1-1.3-4.1-2-6.1-2c-2.5,0-3.8,1.1-3.8,2.5v0.1 c0,1.9,1.3,2.5,6.3,3.8c5.9,1.5,9.3,3.7,9.3,8.8v0.1c0,5.8-4.4,9.1-10.7,9.1C204.9,125.8,201,124.6,197.7,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1,99.1c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2v8.6h11.9v-8.6c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2v23.3 c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2v-8.8h-11.9v8.8c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2V99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2,121.2l10.2-23c0.7-1.6,2-2.5,3.8-2.5h0.4c1.8,0,3,1,3.7,2.5l10.2,23c0.2,0.5,0.3,0.9,0.3,1.3c0,1.7-1.3,3.1-3,3.1 c-1.5,0-2.5-0.9-3.1-2.2l-2-4.6h-12.9l-2,4.8c-0.5,1.3-1.6,2-3,2c-1.7,0-3-1.3-3-3C254.8,122.1,255,121.7,255.2,121.2z  M273.2,113.1l-4.1-9.6l-4.1,9.6H273.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8,99.1c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2v9.8l11.9-11.8c0.8-0.8,1.6-1.3,2.7-1.3c1.8,0,3,1.4,3,3 c0,1-0.5,1.8-1.2,2.4l-8.2,7.7l9,11.3c0.5,0.6,0.9,1.3,0.9,2.3c0,1.8-1.4,3.1-3.3,3.1c-1.3,0-2-0.6-2.7-1.5l-8.4-10.9l-3.7,3.4v5.8 c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2V99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,122.1V99.3c0-1.8,1.4-3.2,3.2-3.2h16.2c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.8-2.9,2.8h-13v5.9H336 c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.8-2.9,2.8h-11.1v6.1h13.2c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.8-2.9,2.8h-16.4 C319.9,125.3,318.5,123.9,318.5,122.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_782",
    transform: "translate(2251 286)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: -1980.3,
    cy: -199.6,
    rx: 7.6,
    ry: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: -1980.3,
    cy: -199.6,
    rx: 5.6,
    ry: 4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11741",
    transform: "translate(1975.399 184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11709",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11677",
    transform: "translate(92.623 41.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24794",
    className: "st5",
    d: "M-1963.9-174.4c-1.4,1.5-1.6,3.9-0.9,7.2l5.3,30.8l0.9,5.1c-0.9-1.4-1.9-2.8-2.9-4.2 l-0.7-4.1l-4.7-27.2c-0.9-3.9-0.5-7,1.4-9c2.4-2.7,7-3.7,14.5-2.9l-0.2,2.2C-1957.8-177.3-1962-176.5-1963.9-174.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11676",
    transform: "translate(12.426 76.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24795",
    className: "st5",
    d: "M-1960.5-146.8l-2.1,0.4l-3.3-19.5l-0.7-4.3c0,0,0,0,0,0c0.5-1.8,1-3.5,1.3-5.4l1,5.6 L-1960.5-146.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11679",
    transform: "translate(85.449 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24796",
    className: "st5",
    d: "M-1901.5-28.6l-2.1-0.4l16.6-96.6c0.4-3.5,0.1-5.8-1.2-7.1c-1.5-1.6-4.7-2-10.9-1.4 c-0.6,0.1-1.1-0.4-1.2-1c0-0.4,0.2-0.8,0.5-1c7.3-4.6,7.2-6.4,7.1-6.7c-0.1-0.3-0.9-1.8-9.3-1.9c-0.6,0-1.1-0.5-1.1-1.1 c0,0,0-0.1,0-0.1c1-11.5-0.1-13.4-0.6-13.7c-0.1-0.1-0.5,0-1.2,0.5c-4.5,6.3-13.5,9.9-13.9,10.1c-0.1,0.1-0.3,0.1-0.4,0.1h-24.9 c-0.4,0-0.8-0.3-1-0.6l-11.7-26.8c-1.2-2.2-4-3-6.2-1.8c-2.2,1.2-3,4-1.8,6.2l12.8,24.4c0.1,0.2,0.1,0.3,0.1,0.5v10h-2.2v-9.7 l-12.7-24.1c-1.8-3.3-0.5-7.4,2.8-9.1c3.3-1.8,7.4-0.5,9.1,2.8l11.4,26.2h24c1.3-0.6,9.1-4,12.9-9.4c0.1-0.1,0.1-0.2,0.2-0.2 c1.4-1.1,2.6-1.3,3.7-0.7c2,1.1,2.6,5.1,1.8,14.6c6.4,0.2,9.5,1.2,10.2,3.5c0.5,1.9-0.9,4.1-4.7,6.8c3.9-0.1,6.8,0.4,8.7,2.3 c1.7,1.8,2.3,4.6,1.8,8.9L-1901.5-28.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11681",
    transform: "translate(97.419 143.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24797",
    className: "st5",
    d: "M-1967.1-157.6l0.1-1.2c0.4-5.8,4.7-11.7,11.5-15.7l1.1,1.9c-5.7,3.4-9.5,8.1-10.3,12.8 l58.9-1.2c-1.3-4.9-4.5-9.1-8.9-11.6l1.1-1.9c5.4,3,9.1,8.3,10.2,14.3l0.2,1.2L-1967.1-157.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11683",
    transform: "translate(95.827 53.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11682"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5583",
    x: -1967.2,
    y: -178.5,
    className: "st5",
    width: 67.4,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11685",
    transform: "translate(98.46 68.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11684"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5584",
    x: -1967,
    y: -177.8,
    className: "st5",
    width: 39.1,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11687",
    transform: "translate(141.774 68.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11686"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5585",
    x: -1965.1,
    y: -177.8,
    className: "st5",
    width: 10.4,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11689",
    transform: "translate(0 66.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24798",
    className: "st5",
    d: "M-1861.5-152.1c-1.4-3.2-3.2-6.2-5.3-8.9c-0.9-1.1-1.8-2.2-2.7-3.2 c-12.4-13-32.8-16.7-62-11.3l-1.3,0.2l0.4,1.2c2.8,8,3.1,13.5,0.7,16.4c-1.9,2.3-5.6,3-11,2.3l-1-0.1l-0.2,1 c-1,4.8-2.8,8-5.4,9.5c-2.3,1.3-5.5,1.4-9.3,0.1c-4.7-2.7-9.4-0.5-11.5,3.2c-1.1,1.8-1.5,4-1.2,6.1c0.4,2.2,1.7,4,3.5,5.2 l0.8,17.9c0.1,3.5,1.3,6.8,3.3,9.7c10.4,14.7,24.2,22,41.2,22c11.9,0,25.4-3.6,40.4-10.8c10.3-6.2,17.3-13.7,21-22.5 c0.6-1.3,1.1-2.7,1.5-4.1C-1856.6-128-1857.2-139.2-1861.5-152.1z M-1861.7-118.6C-1861.7-118.6-1861.7-118.6-1861.7-118.6 c-3.1,10-10.2,18.2-21.3,24.9c-35.3,17-61.8,13.5-78.8-10.5c-1.8-2.5-2.8-5.5-2.9-8.5l-0.9-19.1l-0.5-0.3 c-3.7-2.2-3.7-6-2.1-8.7c0.8-1.4,2.1-2.5,3.6-3c0.6-0.2,1.1-0.3,1.7-0.3c1.2,0,2.3,0.4,3.3,1l0.2,0.1c4.5,1.5,8.2,1.5,11.2-0.2 c3-1.7,5.1-5,6.3-10c5.7,0.6,9.7-0.4,11.9-3.2c2.8-3.4,2.8-9.1,0.1-17.3c29.6-5.3,49.7-0.8,61.1,13.5c1.1,1.3,2,2.7,2.9,4.2 c0.9,1.5,1.7,3,2.4,4.6c3.3,10.2,4.4,19.3,3,27.3v0C-1860.7-122.1-1861.2-120.3-1861.7-118.6L-1861.7-118.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11691",
    transform: "translate(2.731 68.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24799",
    className: "st5",
    d: "M-1966.8-168.8c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5 C-1962.3-170.8-1964.3-168.8-1966.8-168.8z M-1966.8-175.6c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3 C-1964.4-174.6-1965.5-175.6-1966.8-175.6L-1966.8-175.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11693",
    transform: "translate(21.758 66.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24800",
    className: "st5",
    d: "M-1964.2-165.5c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2 C-1958.1-168.3-1960.8-165.5-1964.2-165.5z M-1964.2-175.7c-2.2,0-4,1.8-4,4s1.8,4,4,4c2.2,0,4-1.8,4-4c0,0,0,0,0,0 C-1960.2-173.9-1962-175.7-1964.2-175.7L-1964.2-175.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11695",
    transform: "translate(8.401 82.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24801",
    className: "st5",
    d: "M-1966.2-167.6c-2.6,0-4.8-2.1-4.8-4.8s2.1-4.8,4.8-4.8c2.6,0,4.8,2.1,4.8,4.8 C-1961.5-169.7-1963.6-167.6-1966.2-167.6z M-1966.2-175c-1.4,0-2.6,1.2-2.6,2.6s1.2,2.6,2.6,2.6c1.4,0,2.6-1.2,2.6-2.6 c0,0,0,0,0,0C-1963.6-173.8-1964.8-175-1966.2-175z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11697",
    transform: "translate(111.615 144.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11696"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5586",
    x: -1966.5,
    y: -174.4,
    className: "st5",
    width: 35.1,
    height: 2.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11698",
    transform: "translate(118.93 82.952)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_786",
    className: "st5",
    cx: -1962.3,
    cy: -169.8,
    rx: 3.8,
    ry: 7.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11701",
    transform: "translate(110.58 98.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24803",
    className: "st5",
    d: "M-1947.1-155.6c-9.4,0-19.4-6.5-19.4-20.8h2.2c0,12.8,8.9,18.7,17.3,18.7 s17.3-5.8,17.3-18.7h2.2C-1927.7-162.2-1937.7-155.6-1947.1-155.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11702",
    transform: "translate(59.328 81.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24804",
    className: "st5",
    d: "M-1962.4-164.4c-3.5,0-6.4-2.9-6.4-6.4c0-3.5,2.9-6.4,6.4-6.4c3.5,0,6.4,2.9,6.4,6.4 c0,0,0,0,0,0C-1956-167.3-1958.8-164.4-1962.4-164.4z M-1962.4-175.3c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4 c2.5,0,4.4-2,4.4-4.4c0,0,0,0,0,0C-1957.9-173.3-1959.9-175.3-1962.4-175.3L-1962.4-175.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11703",
    transform: "translate(28.766 99.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24805",
    className: "st5",
    d: "M-1961.6-159.4c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5 C-1953.1-163.2-1956.9-159.4-1961.6-159.4z M-1961.6-174.3c-3.5,0-6.4,2.8-6.4,6.4c0,3.5,2.8,6.4,6.4,6.4c3.5,0,6.4-2.8,6.4-6.4 v0C-1955.3-171.4-1958.1-174.3-1961.6-174.3L-1961.6-174.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11704",
    transform: "translate(57.361 102.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24806",
    className: "st5",
    d: "M-1962.7-164c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1c3.4,0,6.1,2.7,6.1,6.1l0,0 C-1956.6-166.8-1959.3-164-1962.7-164z M-1962.7-174.1c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4 C-1958.7-172.3-1960.5-174.1-1962.7-174.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11705",
    transform: "translate(37.684 122.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24807",
    className: "st5",
    d: "M-1963.1-165c-3.7,0-6.6-2.3-6.6-5.2c0-2.9,3-5.2,6.6-5.2s6.6,2.3,6.6,5.2 C-1956.4-167.3-1959.4-165-1963.1-165z M-1963.1-173.6c-2.7,0-4.8,1.5-4.8,3.4c0,1.9,2.2,3.4,4.8,3.4s4.8-1.5,4.8-3.4 S-1960.4-173.6-1963.1-173.6L-1963.1-173.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11706",
    transform: "translate(83.666 91.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24808",
    className: "st5",
    d: "M-1960.8-163c-3.8,0-6.9-3.1-6.9-6.9c0-3.8,3.1-6.9,6.9-6.9c3.8,0,6.9,3.1,6.9,6.9v0 C-1953.9-166.1-1957-163-1960.8-163z M-1960.8-174.6c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7v0 C-1956.1-172.5-1958.2-174.6-1960.8-174.6L-1960.8-174.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11707",
    transform: "translate(14.449 113.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24809",
    className: "st5",
    d: "M-1940.3-139.7c-10.1,0-20.2-5.4-30.2-16.3c-0.4-0.4-0.4-1.1,0-1.5c0.4-0.4,1.1-0.4,1.5,0 c0,0,0,0,0.1,0.1c16.2,17.6,31.9,20.3,48,8.4c1-11.2,2.6-20.1,12.4-25.6c2.3-1.3,5-1.5,7.4-0.7c6.4,2.3,7.6,9.8,7.5,17.4l7-6.1 c0.5-0.4,1.1-0.3,1.5,0.2c0.4,0.4,0.3,1.1-0.1,1.5l-10.8,9.3l0.1-2.5c0.3-7.6-0.2-15.6-6-17.7c-1.9-0.6-3.9-0.4-5.6,0.5 c-9,5-10.4,13.3-11.4,24.4l0,0.5l-0.4,0.3C-1926.2-142.3-1933.2-139.7-1940.3-139.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11708",
    transform: "translate(69.836 137.094)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5587",
    x: -1969.5,
    y: -171.1,
    transform: "matrix(0.5971 -0.8022 0.8022 0.5971 -655.0382 -1644.2366)",
    className: "st6",
    width: 10.2,
    height: 2.2
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24813",
    className: "st7",
    d: "M155.5,88.1c-4,6.9-8.7,8-8.7,8s7.7-1.5,12,2.2"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 387,
    height: 100,
    xlinkHref: "Group 2.png",
    transform: "matrix(0.25 0 0 0.25 199.1402 223.2399)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M331.9,169H210.1c-9.3,0-16.9-7.5-16.9-16.9v0c0-9.3,7.5-16.9,16.9-16.9h121.8c9.3,0,16.9,7.5,16.9,16.9v0 C348.7,161.4,341.2,169,331.9,169z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.8,151.6L211.8,151.6c0-4.2,3.3-7.6,7.7-7.6c2.2,0,3.7,0.5,5,1.4c0.3,0.2,0.7,0.7,0.7,1.3c0,0.9-0.7,1.6-1.6,1.6 c-0.5,0-0.8-0.2-1-0.3c-0.9-0.6-1.8-1-3.2-1c-2.4,0-4.2,2.1-4.2,4.6v0c0,2.7,1.8,4.7,4.5,4.7c1.2,0,2.2-0.3,3-0.9v-2.1h-2.2 c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4h3.7c0.9,0,1.6,0.7,1.6,1.6v3.6c0,0.9-0.4,1.6-1.1,2.1c-1.2,0.7-2.9,1.5-5.1,1.5 C215,159.2,211.8,155.9,211.8,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.9,157.3v-11.5c0-0.9,0.7-1.6,1.6-1.6h8.1c0.8,0,1.4,0.7,1.4,1.4c0,0.8-0.7,1.4-1.4,1.4h-6.6v3h5.6 c0.8,0,1.4,0.7,1.4,1.4s-0.7,1.4-1.4,1.4h-5.6v3.1h6.7c0.8,0,1.4,0.7,1.4,1.4s-0.7,1.4-1.4,1.4h-8.3 C229.6,158.9,228.9,158.2,228.9,157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,147.2h-3.1c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h9.4c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5h-3.1 v10.2c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6V147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9,145.7c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v4.9l6-5.9c0.4-0.4,0.8-0.6,1.4-0.6c0.9,0,1.5,0.7,1.5,1.5 c0,0.5-0.2,0.9-0.6,1.2l-4.1,3.9l4.5,5.7c0.3,0.3,0.4,0.7,0.4,1.1c0,0.9-0.7,1.6-1.6,1.6c-0.6,0-1-0.3-1.4-0.8l-4.2-5.5l-1.8,1.7 v2.9c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6V145.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6,151.6L276.6,151.6c0-4.2,3.3-7.6,7.8-7.6s7.8,3.4,7.8,7.6v0c0,4.2-3.3,7.6-7.8,7.6S276.6,155.8,276.6,151.6z  M288.8,151.6L288.8,151.6c0-2.6-1.8-4.7-4.5-4.7s-4.4,2.1-4.4,4.6v0c0,2.5,1.8,4.6,4.5,4.6S288.8,154.1,288.8,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.8,157.5L293.8,157.5c0-0.6,0.2-1.1,0.6-1.6l7.6-8.9h-6.5c-0.8,0-1.4-0.6-1.4-1.4s0.7-1.4,1.4-1.4h9.4 c0.8,0,1.4,0.7,1.4,1.4v0.1c0,0.6-0.2,1-0.6,1.5l-7.6,8.9h6.8c0.8,0,1.4,0.7,1.4,1.4c0,0.8-0.7,1.4-1.4,1.4h-9.6 C294.4,158.9,293.8,158.3,293.8,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.2,157.3v-11.5c0-0.9,0.7-1.6,1.6-1.6h8.1c0.8,0,1.4,0.7,1.4,1.4c0,0.8-0.7,1.4-1.4,1.4h-6.6v3h5.6 c0.8,0,1.4,0.7,1.4,1.4s-0.7,1.4-1.4,1.4h-5.6v3.1h6.7c0.8,0,1.4,0.7,1.4,1.4s-0.7,1.4-1.4,1.4h-8.3 C309.9,158.9,309.2,158.2,309.2,157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.3,145.2c-0.1-0.6,0.3-1.1,0.8-1.1h2.1c0.6,0,0.9,0.5,0.8,1.1l-0.9,7.9c-0.1,0.6-0.4,0.9-1,0.9s-0.9-0.4-1-0.9 L329.3,145.2z M331.2,155.4c1,0,1.8,0.8,1.8,1.8v0c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8v0C329.4,156.2,330.2,155.4,331.2,155.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.67955bfadb0a664d2c74cc6d22b45027.svg";
export { ForwardRef as ReactComponent };